import {
  ADD_UPDATE_NAUTILUS_ITEMDETAILS_FAILURE,
  ADD_UPDATE_NAUTILUS_ITEMDETAILS_REQUEST,
  ADD_UPDATE_NAUTILUS_ITEMDETAILS_SUCCESS,
  FETCH_NAUTILUS_ITEMDETAILS_LIST_FAILURE,
  FETCH_NAUTILUS_ITEMDETAILS_LIST_REQUEST,
  FETCH_NAUTILUS_ITEMDETAILS_LIST_SUCCESS,
} from "./actionTypes";
import { NautilusItemDetailsState } from "./types";

// Initial state for item reducer
const initialItemDetailsState: NautilusItemDetailsState = {
  nautilusItemDetailsList: [],
  loadingItemDetails: false,
  errorItemDetails: null,
  totalCountItemDetails: 0,
  successMessageItemDetails: null,
};
//Item details reducer
const nautilusItemDetailsReducer = (
  state = initialItemDetailsState,
  action: any,
): NautilusItemDetailsState => {
  switch (action.type) {
    case FETCH_NAUTILUS_ITEMDETAILS_LIST_REQUEST:
      return {
        ...state,
        loadingItemDetails: true,
        errorItemDetails: null,
      };

    case FETCH_NAUTILUS_ITEMDETAILS_LIST_SUCCESS:
      return {
        ...state,
        loadingItemDetails: false,
        nautilusItemDetailsList:
          action.payload.nautilusItemDetailsList || action.payload,
        totalCountItemDetails: action.payload.totalCount || 0,
      };

    case FETCH_NAUTILUS_ITEMDETAILS_LIST_FAILURE:
      return {
        ...state,
        loadingItemDetails: false,
        errorItemDetails: action.payload,
      };

    case ADD_UPDATE_NAUTILUS_ITEMDETAILS_REQUEST:
      return {
        ...state,
        loadingItemDetails: true,
        errorItemDetails: null,
      };

    case ADD_UPDATE_NAUTILUS_ITEMDETAILS_SUCCESS:
      return {
        ...state,
        loadingItemDetails: false,
        successMessageItemDetails: action.payload,
      };

    case ADD_UPDATE_NAUTILUS_ITEMDETAILS_FAILURE:
      return {
        ...state,
        loadingItemDetails: false,
        errorItemDetails: action.payload,
      };

    default:
      return state;
  }
};

export default nautilusItemDetailsReducer;
